import { get } from "lodash";
import { createSelector } from "reselect";
import { tokens, tokensLoaded, positionTokensLoaded, positionTokens, selectedTokenPair } from "./tokensSelectors";
import { formatUnits } from "@ethersproject/units";
import { getDateString } from "../utils/positionsManagerUtils";
import { marginEventsData, marginEventsLoadedData } from "./marginSelectors";

export const settlementData = state => get(state, "settlements.data", []);
export const settlementDataSelector = createSelector(settlementData, data => data);

export const depositsAndWithdrawalsLoaded = state => get(state, "depositsAndWithdrawals.loaded");
export const depositsAndWithdrawalsLoadedSelector = createSelector(depositsAndWithdrawalsLoaded, loaded => loaded);

export const depositsAndWithdrawalsData = state => get(state, "depositsAndWithdrawals.data");
export const depositsAndWithdrawalsSelector = createSelector(
  depositsAndWithdrawalsData,
  depositsAndWithdrawalsLoaded,
  marginEventsLoadedData,
  marginEventsData,
  tokensLoaded,
  tokens,
  positionTokensLoaded,
  positionTokens,
  selectedTokenPair,
  (
    depositsAndWithdrawalsData,
    depositsAndWithdrawalsLoaded,
    marginEventsLoaded,
    marginEvents,
    tokensLoaded,
    tokens,
    positionTokensLoaded,
    positionTokens,
    selectedTokenPair
  ) => {
    const startTime = new Date().getTime();
    if (
      depositsAndWithdrawalsLoaded &&
      marginEventsLoaded &&
      tokensLoaded &&
      positionTokensLoaded &&
      selectedTokenPair &&
      selectedTokenPair.underlyingTokenPrice
    ) {
      const normalizedUnderlyingPrice = formatUnits(selectedTokenPair.underlyingTokenPrice, 18);
      let decoratedMarginEvents = marginEvents.filter(event => event.wallet);
      decoratedMarginEvents = decoratedMarginEvents.map(event => decorateEvent(event, normalizedUnderlyingPrice, tokens, positionTokens, true));
      const decoratedAccountEvents = depositsAndWithdrawalsData.map(daw => decorateEvent(daw, normalizedUnderlyingPrice, tokens, positionTokens, false));

      const endTime = new Date().getTime();
      if (endTime - startTime > 30) {
        console.log("Selector: depositsAndWithdrawalsSelector took ", endTime - startTime, "mS");
      }
      return [...decoratedMarginEvents, ...decoratedAccountEvents];
    }
    return [];
  }
);

const decorateEvent = (event, normalizedUnderlyingPrice, tokens, positionTokens, isMarginEvent) => {
  let tokenAddress;
  let isDeposit;
  if (isMarginEvent) {
    tokenAddress = event.assetAddress;
    isDeposit = isDepositEvent(event.action);
  } else {
    tokenAddress = event.token;
    isDeposit = event.isDeposit;
  }
  const normalizedAmount = parseFloat(formatUnits(event.amount.toString(), 18));
  // const printableAmount = parseFloat(normalizedAmount).toFixed(2);
  const printableAmount = parseFloat(normalizedAmount).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const underlyingTokenAddress = tokens.find(token => token.symbol === "ETH").address;
  const normalizedValue =
    tokenAddress === underlyingTokenAddress ? parseFloat(normalizedAmount) * parseFloat(normalizedUnderlyingPrice) : parseFloat(normalizedAmount);
  // const printableValue = parseFloat(normalizedValue).toFixed(2);
  const printableValue = parseFloat(normalizedValue).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  let matchingToken = tokens.find(asset => asset.address === tokenAddress);
  let tokenSymbol;
  if (!matchingToken) {
    matchingToken = positionTokens.find(asset => asset.address === tokenAddress);
  }
  tokenSymbol = matchingToken.symbol;

  const dateString = getDateString(new Date(event.timestamp * 1000));

  return {
    isDeposit,
    normalizedAmount,
    printableAmount,
    normalizedValue,
    printableValue,
    tokenSymbol,
    timestamp: event.timestamp,
    readableTimestamp: dateString
  };
};

const isDepositEvent = action => {
  return action === "LEND" || action == "REPAY";
};
